import {
    Box, Button, useDisclosure,
} from "@chakra-ui/react"; import UserTable from "./components/UserTable";
import { useHistory } from "react-router-dom";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { useEffect, useState } from "react";
import { AddUser } from "./components/AddUser";
import { MdAdd } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import { ConfirmDeleteModal } from "components/modal/ConfirmDeleteModal";
import { EditUser } from "./components/EditUser";

export function UserManagement() {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsloading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const { isOpen: isAddOpen, onOpen: onAddOpen, onClose: onAddClose } = useDisclosure();
    const { isOpen: isDelOpen, onOpen: onDelOpen, onClose: onDelClose } = useDisclosure();
    const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure();
    const [agentData, setAgentData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [creator, setCreator] = useState('');
    const [token, setToken] = useState();
    let navigate = useHistory();

    useEffect(() => {
        const clientInfo = sessionStorage.getItem('clientInfo');
        const key = sessionStorage.getItem('token');

        if (clientInfo) {
            const { clientName, role } = JSON.parse(clientInfo);
            if (role === 'User') {
                navigate.push('/auth');
            }
            setCreator(clientName);
            setToken(key);

            getUsers(key);
            getAgents(key);
            getRoles(key);
        }
        else
            navigate.push('/auth');
    }, []);

    const getUsers = async (key) => {
        try {
            setIsloading(true);

            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }

            const response = await axios.get(getAPIEndpoint('user'), apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    setUsers(data);
                }
                else
                    setUsers([]);
            }
        } catch (error) {
            await logger({ task: "Get Users", error: error.toString() });
        }
        setIsloading(false);
    }

    const getAgents = async (key) => {
        try {
            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }

            const response = await axios.get(getAPIEndpoint('agent'), apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    setAgentData(data);
                }
                else {
                    setAgentData([]);
                }
            }

        } catch (error) {
            await logger({ task: "Get Agents", error: error.toString() });
        }
    }

    const getRoles = async (key) => {
        try {
            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }

            const response = await axios.get(getAPIEndpoint('role'), apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    setRoleData(data);
                }
                else {
                    setRoleData([]);
                }
            }
        } catch (error) {
            await logger({ task: "Get Roles", error: error.toString() });
        }
    }

    const deleteFn = (row) => {
        setSelectedRow(row);
        onDelOpen();
    }

    const editFn = (row) => {
        setSelectedRow(row);
        onEditOpen();
    }

    const deleteUser = async (key) => {
        try {
            setIsDeleting(true);

            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }

            const response = await axios.post(getAPIEndpoint('user-delete'), { username: selectedRow.username, creator }, apiHeader);
            if (response) {
                const { status } = response.data;
                if (status === 'success') {
                    await getUsers(key);
                    onDelClose();
                }
                else {
                    toast.error('Sorry, we are unable to delete user data at this time. Please try again later.');
                }
            }
        } catch (error) {
            await logger({ task: "Delete User", error: error.toString() });
        }
        setIsDeleting(false);
    }

    const showUserDialog = () => {
        onAddOpen();
    }

    const props = {
        isLoading,
        data: users,
        showUserDialog,
        addControl: <Button
            fontSize={{ base: "12px", md: "15px" }}
            color={"white"}
            bg={"#0C7FE9"}
            _hover={{
                bg: "#3c98ed"
            }}
            w={'160px'}
            h={'45px'}
            leftIcon={<MdAdd size={"22px"} />}
            onClick={showUserDialog}
        >
            Add New User
        </Button>,
        deleteFn,
        editFn
    }

    const modalProps = {
        isOpen: isAddOpen,
        onClose: onAddClose,
        refreshData: getUsers,
        roles: roleData,
        clients: agentData,
        creator,
        authKey: token
    }

    const modalPropsDel = {
        isOpen: isDelOpen,
        onClose: onDelClose,
        deleteFn: deleteUser,
        tag: 'user',
        isDeleting,
        authKey: token
    }

    const modalPropsEdit = {
        isOpen: isEditOpen,
        onClose: onEditClose,
        userData: selectedRow,
        refreshData: getUsers,
        roles: roleData,
        clients: agentData,
        creator,
        authKey: token
    }

    return (
        <>
            <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                <UserTable {...props} />
            </Box>
            <AddUser {...modalProps} />
            {selectedRow && <ConfirmDeleteModal  {...modalPropsDel} />}
            {selectedRow && <EditUser {...modalPropsEdit} />}
            <ToastContainer />
        </>
    )
}